import { type BlogFrontmatter } from "@/services/blog.ts";
// eslint-disable-next-line no-restricted-imports
import headerImage from "./header_image.avif";
// eslint-disable-next-line no-restricted-imports
import { height, width } from "./header_image.avif?as=metadata:height;width";
// eslint-disable-next-line no-restricted-imports
import headerImageSrcset from "./header_image.avif?w=480;960;1920&format=avif&as=srcset";

export const frontmatter: BlogFrontmatter = {
  title: "Protect Microsoft 365 with Controla",
  header: "Protect Microsoft 365 with Controla",
  date: "2026-09-07",
  description:
    "Protect Microsoft 365 with Controla. Find account security gaps, risky sign-ins and overshared files, then fix them with guided and automated actions.",
  category: "product",
  draft: false,
  authorKey: "agnes_onne",
  headerImage,
  headerImageSrcset,
  headerImageDimensions: {
    height,
    width,
  },
};
